import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { axiosInstnace as Axios } from "../../util/util";
import { submit, destroy } from "redux-form";
import { ToastContainer, toast } from "react-toastify";
import { NavLink } from "react-router-dom";
import { Tabs, Tab } from "react-web-tabs";

import "react-toastify/dist/ReactToastify.css";
import "react-web-tabs/dist/react-web-tabs.css";
import SignUp from "./signUp";
import Login from "./login";
import { endPoints } from "../../config";
import { history } from "../../history/history";
import { setUserData } from "../../util/util";
import AOS from "aos";
AOS.init();

const Signup_Login = (props) => {
  //Set initial state
  const [tabId, handleTabId] = useState("signup");
  const [activeSignUp, handleActiveSignUp] = useState("active_tab_btn");
  const [activeLogin, handleActiveLogin] = useState("");

  const keyPressed = (event) => {
    if (event.key === "Enter") {
      console.log("Enter key Pressed");
    }
  };

  //submit login
  const onLoginSubmit = (values) => {
    console.log("clicked login button");
    if (values.hasOwnProperty("email") && values.hasOwnProperty("password")) {
      login(values);
    } else if (Object.keys(values).length != 0 && !toast.isActive("1")) {
      toast.error("All Fields Are Mandatory", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
    }
  };

  //Validate for signup
  const onSignUpSubmit = (values) => {
    let { email } = values;
    let domain = email.slice(email.lastIndexOf("@") + 1);
    console.log("Email domain", domain);
    if (domain === "radiobigfm.com") {
      toast.error("radiobigfm users are not allowed to SIGN UP", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    } else if (
      values.hasOwnProperty("name") &&
      values.hasOwnProperty("industry") &&
      values.hasOwnProperty("company") &&
      values.hasOwnProperty("state") &&
      values.hasOwnProperty("city") &&
      values.hasOwnProperty("email") &&
      values.hasOwnProperty("mobile") &&
      values.hasOwnProperty("password") &&
      values.hasOwnProperty("confirmPassword")
    ) {
      /* && values.hasOwnProperty('district')*/
      if (
        values.password &&
        values.confirmPassword &&
        values.password === values.confirmPassword
      ) {
        signUp(values);
      } else {
        toast.error("Password and Confirm Password should be same", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: false,
          hideProgressBar: true,
          toastId: "1",
        });
        return;
      }
    } else if (Object.keys(values).length != 0 && !toast.isActive("1")) {
      toast.error("All Fields Are Mandatory", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
  };

  //User signup
  const signUp = async (values) => {
    
    var loginBtton = document.getElementById("login-tab");
    let value = {
      ...values,
      role: "user",
    };
    try {
      const data = await Axios.post(endPoints.signup, value);
      if (data.data.httpCode === 400 && !toast.isActive("1")) {
        toast.error("Invalid Input", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: false,
          hideProgressBar: true,
          toastId: "1",
        });
        return;
      } else if (data.data.statusCode === 200) {
        verifyEmail(values.email);
        toast.success(
          "Thank you for registering, please verify your email to continue.",
          {
            position: toast.POSITION.TOP_CENTER,
            autoClose: false,
            hideProgressBar: true,
            toastId: "1",
          }
        );
        setTimeout(() => {
          loginBtton.click();
        }, 2000);
      }
      if (data.data.err && !toast.isActive("1")) {
        toast.error("User has already exits", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: false,
          hideProgressBar: true,
          toastId: "1",
        });
        return;
      }
    } catch (error) {}
  };

  //User login
  const login = async (values) => {
    try {
      const data = await Axios.post(endPoints.login, values);
      if (
        data.data.data &&
        props.location.state &&
        props.location.state.packageDetails
      ) {
        let packages = {
          ...props.location.state.packageDetails,
          userEmail: data.data.data.data.email,
        };
        if (data.data.data.data.verified) {
          console.log("User Verified");
          setUserData(data.data.data.data);
          assignPackageToUser(packages);
          window.location.reload(true)
        } else {
          console.log("User Not verified");
          verifyEmail(data.data.data.data.email);
          toast.error("Verification email sent, Please verify your email", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: false,
            hideProgressBar: true,
            toastId: "1",
          });
        }
      } else if (data.data.data) {
        if (data.data.data.data.verified) {
          console.log("User Verified");
          setUserData(data.data.data.data);
          history.push("/dashboard");
          window.location.reload(true)
        } else {
          console.log("User Not verified");
          verifyEmail(data.data.data.data.email);
          toast.error("Verification email sent, Please verify your email", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: false,
            hideProgressBar: true,
            toastId: "1",
          });
        }
      } else {
        toast.error(data.data.message ? data.data.message : data.data);
      }
    } catch (error) {
      toast.error("Invalid Credentials", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
    }
  };

  //Assign a package to user
  const assignPackageToUser = async (packages) => {
    history.push({
      pathname: "/campaign",
      state: { packageDetails: packages },
    });
  };

  //Handle active tab for signup and login
  const handleActiveTab = (tabId) => {
    handleTabId(tabId);
    if (tabId === "signup") {
      handleActiveSignUp("active_tab_btn");
      handleActiveLogin("");
    } else {
      handleActiveLogin("active_tab_btn");
      handleActiveSignUp("");
    }
  };

  const get = () => {
    return;
  };

  const handleKeyPress = (e) => {
    console.log("enter");
    if (e.key === "Enter") {
      console.log("Entering a Key");
    }
  };

  const verifyEmail = (email) => {
    Axios.get(endPoints.verifyUserEmail, {
      params: {
        email,
      },
    });
  };

  return (
    <div>
      <title>Buyadsonbigfm</title>
      <div className="login_wrapper">
        <div className="login_bg">
          <div className="login_circle">
            <img
              className="circle1"
              src="../../assets/images/circle_login.png"
            />
            <div className="login_logo">
              {" "}
              <NavLink to="/">
                <img src="../../assets/images/new_logo.png" />
              </NavLink>
            </div>
          </div>
          <div className="mic_wrapper">
            <img src="../../assets/images/mic_login.png" />
          </div>
        </div>
        <div className="login_form_wrapper">
          <div className="login_form_logo">
            <img src="../../assets/images/logo_watermark.png" />
          </div>
          <div className="login_form">
            <h2>
              WELCOME TO <span>BIGFM 92.7</span>
            </h2>
            <Tabs
              defaultTab="signup"
              onChange={(tabId) => {
                handleActiveTab(tabId);
              }}
            >
              <SignUp onSubmit={onSignUpSubmit} />
              <Login onSubmit={onLoginSubmit} />
              <div className="tab_wrapper">
                <Tab
                  className={`common_tab ${activeSignUp}`}
                  tabFor="signup"
                  onClick={activeSignUp ? props.submitSignUpForm : get}
                >
                  SIGN UP
                </Tab>
                <Tab
                  className={`common_tab ${activeLogin}`}
                  tabFor="login"
                  onClick={activeLogin ? props.submitLoginForm : get}
                  onKeyPress={(e) => handleKeyPress(e)}
                >
                  LOGIN
                </Tab>
              </div>
            </Tabs>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      submitLoginForm: () => submit("login"),
      submitSignUpForm: () => submit("signup"),
      destroyForm: destroy,
    },
    dispatch
  );
};

export default connect(null, mapDispatchToProps)(Signup_Login);



// WEBPACK FOOTER //
// ./web/components/signUp/index.js